import { isProd } from 'services/Utilities'
import { datadogRum } from '@datadog/browser-rum'

const employeeActions = ['OPEN_HELP_CENTER', 'OPEN_HELP_VIDEOS', 'OPEN_WHATS_NEW', 'OPEN_MY_SCHEDULE', 'CONFIRM_MY_SHIFTS', 'OPEN_MY_MESSAGES', 'PUNCH_IN_OUT']
const managerActions = [
  'CREATE_SHIFT',
  'EDIT_SHIFT',
  'AUTOFILL_SHIFTS',
  'CONFIRM_SHIFTS',
  'COPY_PASTE_SHIFTS',
  'PUBLISH_SHIFTS',
  'CREATE_SCHEDULE_TEMPLATE',
  'CREATE_USER',
  'ONBOARD_USER',
  'ACTION_ABSENCE',
  'ACTION_TIMEOFF',
  'ACTION_AVAILABILITY',
  'ACTION_PUNCH_CARD',
  'CREATE_CONTACT_LIST',
  'CREATE_BULLETIN',
  'CREATE_PROJECT',
  'CREATE_TIMEOFF',
  'CREATE_ATTENDANCE',
  'CREATE_POSITION',
  'UPDATE_POSITION',
  'CREATE_AVAILABILITIES',
  'START_CONTACT_LIST',
  'GET_SCHEDULE_ISSUES'
]

const allActions = [...employeeActions, ...managerActions]
/**
 * Function to track an action made by the user
 * @param {string} action Action key to track
 * @param {object} metadata payload of the action
 * @param {function} cb function to call when the action has been tracked
 */
export const TrackAction = (action, metadata = {}) => {
  if (!allActions.includes(action)) throw new Error('Nonexistant action')

  // Send action to intercom
  window.Intercom('trackEvent', action, metadata)

  // Send action to datadog
  if (isProd) datadogRum.addAction(action, metadata)
}
